import React from 'react';
import { classNames } from '../utils/formatters';

const BottomNavIcon = ({ name }) => {
  const sharedProps = {
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
  };

  switch (name) {
    case 'pos':
      return <svg {...sharedProps}><path d="M4 7h16" /><path d="M6 7l1 11a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2l1-11" /><path d="M9 10h6" /><path d="M10 14h4" /></svg>;
    case 'queue':
      return <svg {...sharedProps}><rect x="3" y="5" width="18" height="14" rx="2" /><path d="M3 10h18" /><path d="M7 15h2" /><path d="M12 15h5" /></svg>;
    case 'kitchen':
      return <svg {...sharedProps}><path d="M4 4v8" /><path d="M7 4v8" /><path d="M10 4v8" /><path d="M7 12v8" /><path d="M15 4c1.657 0 3 1.567 3 3.5V20" /><path d="M18 4v16" /></svg>;
    default:
      return <svg {...sharedProps}><path d="M4 7h16" /><path d="M8 12h8" /><path d="M6 17h12" /></svg>;
  }
};

const primaryTabs = ['pos', 'queue', 'kitchen'];

export default function BottomNav({
  currentTab,
  onSelectTab,
  onOpenMore,
  queueCount = 0,
  kitchenCount = 0,
}) {
  const isMoreActive = !primaryTabs.includes(currentTab);

  const items = [
    { id: 'pos', label: 'POS', badge: 0 },
    { id: 'queue', label: 'Queue', badge: queueCount },
    { id: 'kitchen', label: 'Kitchen', badge: kitchenCount },
  ];

  return (
    <nav className="pos-bottom-nav" aria-label="Main navigation">
      {items.map((item) => (
        <button
          key={item.id}
          type="button"
          onClick={() => onSelectTab(item.id)}
          className={classNames('pos-bottom-nav-item', currentTab === item.id && 'active')}
        >
          <span className="mobile-nav-icon relative">
            <BottomNavIcon name={item.id} />
            {item.badge > 0 && (
              <span className="badge-dot">
                {item.badge > 9 ? '9+' : item.badge}
              </span>
            )}
          </span>
          <span>{item.label}</span>
        </button>
      ))}

      <button
        type="button"
        onClick={onOpenMore}
        className={classNames('pos-bottom-nav-item', isMoreActive && 'active')}
      >
        <span className="mobile-nav-icon">
          <BottomNavIcon name="more" />
        </span>
        <span>More</span>
      </button>
    </nav>
  );
}
